import React, { useEffect, useState } from 'react';
import logo from '../../../Images/logo.png';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { loginData } from '../../../Utils/loginSlice';
import { toogleReload } from '../../../Utils/reloadSlice';
import { toogleOnlineEvent } from '../../../Utils/onlineEventSlice';

const OnlineEvents = ({setEditEvent}) => {
  const clipBoard = navigator.clipboard;
  const [loading, setLoading] = useState(false);
  const [event, setEvent] = useState([]);
  const isReload = useSelector((store) => store.reload.isReload);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleSignOut = () => {
    dispatch(loginData("notexist"));
    navigate('/');
  }

  useEffect(() => {
    getData();
  }, [isReload]);

  const getData = async () => {
    const fetchData = await fetch('https://app-api.mokx.org/api/v1/online_event');
    const json = await fetchData.json();
    setEvent(json.data.onlineEvents[0]);
  }

  const handleEdit = async () => {
    setLoading(true);
    const getData = await fetch(`https://app-api.mokx.org/api/v1/online_event`);
    const json = await getData.json();
    setEditEvent(json.data.onlineEvents[0]);
    setTimeout(() => {
      dispatch(toogleOnlineEvent());
    }, 500)
    setLoading(false);
  }

  const handleCopy = (link) => {
    clipBoard.writeText(link).then(() => {
      alert("Copied event link to clipboard successfully");
    });
  }

  return (
    <>
      <div className="w-full h-screen">
        <div className="w-full py-5 flex flex-col gap-7">
          <div className="flex justify-between">
            <h1 className="text-[#000] text-2xl font-montserrat font-bold">
              Online Event
            </h1>
            <div className='flex gap-5'>
              <div className='bg-clip flex justify-between items-center gap-3 rounded-[20px] px-3 text-[#FFF] cursor-pointer select-none' onClick={() => dispatch(toogleReload())}>
                Reload
                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 512 512">
                  <path fill="white" d="M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208s208-93.31 208-208S370.69 48 256 48Zm120 182.15a8.62 8.62 0 0 1-8.62 8.62h-59.54a8.61 8.61 0 0 1-6.09-14.71l22.17-22.17l-5.6-6.51a87.38 87.38 0 1 0-62.94 148a87.55 87.55 0 0 0 82.42-58.25A16 16 0 1 1 368 295.8a119.4 119.4 0 1 1-112.62-159.18a118.34 118.34 0 0 1 86.36 36.95l.56.62l4.31 5l14.68-14.68a8.44 8.44 0 0 1 6-2.54a8.61 8.61 0 0 1 8.68 8.63Z"/>
                </svg>
              </div>
              <div className="w-[40px] h-[40px] pt-[3PX] bg-[#C4C4C4] rounded-full overflow-hidden cursor-pointer" onClick={() => handleSignOut()}>
                <img className='scale-110' src={logo} alt="usericon" />
              </div>
            </div>
          </div>
          <div className="flex flex-wrap gap-9">
            <div className="relative lg:w-[48%] md:w-[48%] w-[100%] bg-[#FFF] rounded-xl drop-shadow-3Xl py-7 pr-9 pl-10 mb-4 flex flex-col justify-center gap-4">
              <div className='text-[#000] text-xl font-figtree font-semibold flex items-center'>
                {"Event Link"}
                <div className='cursor-pointer' onClick={() => handleCopy(event.onlineEventLink)}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                    <path fill="none" stroke="#717171" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.4" d="M20.829 12.861c.171-.413.171-.938.171-1.986s0-1.573-.171-1.986a2.25 2.25 0 0 0-1.218-1.218c-.413-.171-.938-.171-1.986-.171H11.1c-1.26 0-1.89 0-2.371.245a2.25 2.25 0 0 0-.984.984C7.5 9.209 7.5 9.839 7.5 11.1v6.525c0 1.048 0 1.573.171 1.986c.229.551.667.99 1.218 1.218c.413.171.938.171 1.986.171s1.573 0 1.986-.171m7.968-7.968a2.25 2.25 0 0 1-1.218 1.218c-.413.171-.938.171-1.986.171s-1.573 0-1.986.171a2.25 2.25 0 0 0-1.218 1.218c-.171.413-.171.938-.171 1.986s0 1.573-.171 1.986a2.25 2.25 0 0 1-1.218 1.218m7.968-7.968a11.678 11.678 0 0 1-7.75 7.9l-.218.068M16.5 7.5v-.9c0-1.26 0-1.89-.245-2.371a2.25 2.25 0 0 0-.983-.984C14.79 3 14.16 3 12.9 3H6.6c-1.26 0-1.89 0-2.371.245a2.25 2.25 0 0 0-.984.984C3 4.709 3 5.339 3 6.6v6.3c0 1.26 0 1.89.245 2.371c.216.424.56.768.984.984c.48.245 1.111.245 2.372.245H7.5"/>
                  </svg>
                </div>
              </div>
              <div className='text-[#000] text-xl font-figtree font-medium'>Date of Event: {event.dateOfEvent}</div>
              <div className='text-[#000] text-xl font-figtree font-medium'>Cost in Doller: ${event.costInDollar}</div>
              <div className='text-[#000] text-xl font-figtree font-medium'>Cost in Rupee: ₹{event.costInRupee}</div>
              <div className='flex gap-7'>
                <div>
                  <img className='w-[80px] h-[80px]' src={event.imageLink} alt="" />
                  <span className='text-[#000] text-base font-figtree font-medium'>App Image</span>
                </div>
                <div>
                  <img className='w-[80px] h-[80px]' src={event.webImageLink} alt="" />
                  <span className='text-[#000] text-base font-figtree font-medium'>Web Image</span>
                </div>
              </div>
              {event.length !== 0 && <div className='absolute right-1 top-1 cursor-pointer flex gap-1'>
                <button disabled={loading} onClick={() => handleEdit()}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24">
                    <path fill={loading? "#86B0F4":"#286de0"} d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10s10-4.47 10-10S17.53 2 12 2m3.1 5.07c.14 0 .28.05.4.16l1.27 1.27c.23.22.23.57 0 .78l-1 1l-2.05-2.05l1-1c.1-.11.24-.16.38-.16m-1.97 1.74l2.06 2.06l-6.06 6.06H7.07v-2.06l6.06-6.06Z"/>
                  </svg>
                </button>
              </div>}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default OnlineEvents;